// quick-view slider
    document.addEventListener('DOMContentLoaded', function () {
        const slider = document.querySelector('.qv-slider');
        const slides = document.querySelectorAll('.qv-slide');
        const container = document.querySelector('.qv-slider-container');
        const indicatorsContainer = document.querySelector('.qv-slider-indicators');
        const prevButton = document.getElementById('qv-prev-btn');
        const nextButton = document.getElementById('qv-next-btn');
        let currentIndex = 0;

        if (currentIndex === 0) {
            prevButton.querySelector('img').src = 'https://cdn.shopify.com/s/files/1/0838/9971/1770/files/Property_1_left_inactive.svg?v=1701937411';
            nextButton.querySelector('img').src = 'https://cdn.shopify.com/s/files/1/0838/9971/1770/files/Property_1_right_active.svg?v=1701937411';
        }

        container.addEventListener('mouseenter', function () {
            container.classList.add('hovered');
        });

        container.addEventListener('mouseleave', function () {
            container.classList.remove('hovered');
        });

        let touchStartX = 0;

        container.addEventListener('touchstart', (e) => {
            touchStartX = e.touches[0].clientX;
        });

        container.addEventListener('touchend', (e) => {
            const touchEndX = e.changedTouches[0].clientX;
            const touchDiff = touchEndX - touchStartX;

            if (touchDiff > 50 && currentIndex > 0) {
                currentIndex--;
                updateSlider();
            } else if (touchDiff < -50 && currentIndex < slides.length - 1) {
                currentIndex++;
                updateSlider();
            }
        });

        window.addEventListener('resize', () => {
            currentIndex = Math.round(slider.scrollLeft / container.clientWidth);
            updateSlider();
        });

        indicatorsContainer.addEventListener('click', function (event) {
            const clickedIndex = Array.from(indicatorsContainer.children).indexOf(event.target);
            if (clickedIndex !== -1) {
                currentIndex = clickedIndex;
                updateSlider();
            }
        });

        prevButton.addEventListener('click', function () {
            if (currentIndex > 0) {
                currentIndex--;
                updateSlider();
            }
        });

        nextButton.addEventListener('click', function () {
            if (currentIndex < slides.length - 1) {
                currentIndex++;
                updateSlider();
            }
        });

        function updateSlider() {
            const newTransformValue = -currentIndex * 100 + '%';
            slider.style.transform = 'translateX(' + newTransformValue + ')';

            // Update indicators
            Array.from(indicatorsContainer.children).forEach((indicator, index) => {
                if (index === currentIndex) {
                    indicator.classList.add('active');
                } else {
                    indicator.classList.remove('active');
                }
            });

            // Disable/enable and change button color
            prevButton.disabled = currentIndex === 0;
            nextButton.disabled = currentIndex === slides.length - 1;
            prevButton.style.cursor = currentIndex === 0 ? 'not-allowed' : '';
            nextButton.style.cursor = currentIndex === slides.length - 1 ? 'not-allowed' : '';

            // Change image URL when buttons are disabled
            if (prevButton.disabled) {
                prevButton.querySelector('img').src = 'https://cdn.shopify.com/s/files/1/0838/9971/1770/files/Property_1_left_inactive.svg?v=1701937411';
            } else {
                prevButton.querySelector('img').src = 'https://cdn.shopify.com/s/files/1/0838/9971/1770/files/Property_1_left_active_1.svg?v=1701937411';
            }

            if (nextButton.disabled) {
                nextButton.querySelector('img').src = 'https://cdn.shopify.com/s/files/1/0838/9971/1770/files/Property_1_right_inactive_1.svg?v=1701937411';
            } else {
                nextButton.querySelector('img').src = 'https://cdn.shopify.com/s/files/1/0838/9971/1770/files/Property_1_right_active.svg?v=1701937411';
            }
        }

        slides.forEach((slide, index) => {
            const indicator = document.createElement('div');
            indicator.classList.add('qv-indicator');
            indicator.innerHTML = '';
            if (index === 0) {
                indicator.classList.add('active');
            }
            indicatorsContainer.appendChild(indicator);
        });
    });
// price matching based on varient

function formatShopifyPrice(price) {
  return new Intl.NumberFormat('it-IT', {
    style: 'currency',
    currency: 'EUR',
    currencyDisplay: 'symbol',
  }).format(price / 100);
}

document.addEventListener("DOMContentLoaded", function() {
  const parent_ = document.querySelector(".quick-view-container");
  const firstColorElement = parent_.querySelector(".quick-view-colors");

  // Set color name for the first iteration
  const colorNameElement = parent_.querySelector("#color-name");

  document.addEventListener("click", function(e) {
    const sizesElement = e.target.closest(".quick-view-sizes");
    const colorsElement = e.target.closest(".quick-view-colors");

    const allSizeValues = parent_.querySelectorAll(".quick-view-sizes");
    const allColorValues = parent_.querySelectorAll(".quick-view-colors");
    const addToCartBtn = parent_.querySelector(".add-to-cart-btn");
    const variantObjectPrice = parent_.querySelector("#product-data").innerHTML;
    const objectData = JSON.parse(variantObjectPrice);
    const cardPrice = parent_.querySelector(".price-wrapper");
    const comparePriceWrapper = parent_.querySelector(".compare-price-wrapper");

    // Handle size selection
    if (sizesElement) {
      // Remove active state from all sizes
      allSizeValues.forEach(sizeElement => {
        sizeElement.classList.remove("active");
      });
      // Add active state for the selected size
      sizesElement.classList.add("active");
    }

    // Handle color selection
    if (colorsElement) {
      // Remove active state from all colors
      allColorValues.forEach(colorElement => {
        colorElement.classList.remove("active");
      });
      // Add active state for the selected color
      colorsElement.classList.add("active");

      // Set color name
      colorNameElement.textContent = e.target.textContent;
    }

    // Get the selected size and color
    const selectedSize = [...allSizeValues].find(el => el.classList.contains("active"))?.querySelector(".variant_value")?.innerHTML || "";
    const selectedColor = [...allColorValues].find(el => el.classList.contains("active"))?.querySelector(".variant-color_value")?.innerHTML || "";
    // console.log("Selected Size:", selectedSize);
    // console.log("Selected Color:", selectedColor);

    const matchingVariant = objectData.variants.find(variant => {
      return variant.option1 === selectedSize && variant.option2 === selectedColor;
    });

    // console.log("Matching Variant:", matchingVariant);
    // console.log("All Variants:", objectData.variants);

    if (matchingVariant) {
      const selectedVariant = matchingVariant.id;
      parent_.querySelector("input[name='id']").value = selectedVariant;

      cardPrice.innerHTML = formatShopifyPrice(matchingVariant.price)
      cardPrice.innerHTML = cardPrice.innerHTML.replace(/&nbsp;/g, '');
      console.log("form:", formatShopifyPrice(matchingVariant.price))

      if (objectData.compare_at_price && matchingVariant.compare_at_price) {
        comparePriceWrapper.innerHTML = formatShopifyPrice(matchingVariant.compare_at_price);
        comparePriceWrapper.innerHTML = comparePriceWrapper.innerHTML.replace(/&nbsp;/g, '');
      } else {
        comparePriceWrapper.innerHTML = "";
      }

      if (matchingVariant.available) {
        addToCartBtn.removeAttribute("disabled");
        addToCartBtn.value = "Aggiungi al carrello";
      } else {
        addToCartBtn.setAttribute("disabled", "true");
        addToCartBtn.value = "Esaurito";
      }
    } else {
      if (selectedSize === "" && selectedColor === "") {
        addToCartBtn.removeAttribute("disabled");
        addToCartBtn.value = "Aggiungi al carrello";
      } else {
        addToCartBtn.setAttribute("disabled", "true");
        addToCartBtn.value = "Please Select Both Fields";
      }
    }
  });
});
